export const BANK_CARD_INIT_TIMEOUT = 5000;
